/**
 * 删除字符串的前置0
 *
 * @param {string} str
 */
export function removeFrontZero(str) {
	return str.replace(/\b(0+)/gi, "");
}

/**
 *
 * 格式化电话号码
 * @param {string} string
 */
export function formatPhone(string) {
	let str = string.toString().replace(/[^0-9]+/g, "");
	let len = str.length;
	let output = "";
	switch (true) {
		case len >= 8 && len <= 10:
			output = `(${str.substr(0, 3)}) ${str.substr(3, 3)}-${str.substr(6)}`;
			break;
		case len > 3 && len <= 8:
			output = `${str.substr(0, 3)}-${str.substr(3)}`;
			break;
		default:
			output = str;
	}
	return output;
}

/**
 *
 * 格式化个人信息电话号码
 * @param {string} string
 */
export function personageFormatPhone(string) {
	let str = string.toString().replace(/[^0-9]+/g, "");
	let len = str.length;
	let output = "";
	switch (true) {
		case len >= 8 && len <= 10:
			output = `${str.substr(0, 3)}-${str.substr(3, 3)}-${str.substr(6)}`;
			break;
		case len > 3 && len <= 8:
			output = `${str.substr(0, 3)}-${str.substr(3)}`;
			break;
		default:
			output = str;
	}
	return output;
}

/**
 *
 * 处理电话号码
 * @param {string} string
 */
export function trimPhone(string) {
	return string.replace("(", "").replace(")", "").replace(" ", "").replace("-", "");
}
